import * as React from 'react';
import { connect } from 'react-redux';

import './UploadPage.css';

import { addUploads } from '../actions';
import FileRow from '../components/FileRow';
import { IUploadData } from '../reducers/uploadsReducer';
import { RootState } from '../types';


interface IProps {
    onAddUploads: (files: File[]) => void,
    uploads: IUploadData[],
}

export class UploadPage extends React.Component<IProps> {

    public render() {
        const {uploads} = this.props;
        return (<div className="upload-section container">
            <form action="#">
                <div className="upload-header">
                    <h3>Upload</h3>
                    <input
                        id="file"
                        multiple={true}
                        accept=".wav, .mp3, .m4a, .aac, .opus, .wma"
                        className="add-file"
                        onChange={this.onFileChange}
                        type="file"/>
                    <label className="add-file-button" htmlFor="file"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><path d="M26 0C11.664 0 0 11.663 0 26s11.664 26 26 26 26-11.663 26-26S40.336 0 26 0zm0 50C12.767 50 2 39.233 2 26S12.767 2 26 2s24 10.767 24 24-10.767 24-24 24z"/><path d="M38.5 25H27V14a1 1 0 1 0-2 0v11H13.5a1 1 0 1 0 0 2H25v12a1 1 0 1 0 2 0V27h11.5a1 1 0 1 0 0-2z"/></svg></label>
                </div>
            </form>
            <table className="uploads-table">
                <tbody>
                    {
                        uploads.map((u, i) => <FileRow
                            state={u.state}
                            file={u.file}
                            error={u.error}
                            key={i} />)
                    }
                </tbody>
            </table>
        </div>)
    }

    private onFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();

        const {files} = e.currentTarget;
        if (!files) {
            return;
        }

        const infos = [];
        
        for (let i = 0; i < files.length; i++) {
            const file = files.item(i);
            if (!file) { continue; }

            infos.push(file);
        }

        this.props.onAddUploads(infos);
    }

}

export const UploadPageContainer = connect(
    ({uploads}: RootState) => {
        const datas: IUploadData[] = [];
        uploads.queue.forEach(id => {
            const data = uploads.data[id];
            if (!data) {
                return;
            }
            datas.push(data);
        });

        return {uploads: datas};
    },
    dispatch => ({
        onAddUploads: (files: File[]) => { dispatch(addUploads(files)) },
    }),
)(UploadPage);

export default UploadPageContainer;



// WEBPACK FOOTER //
// ./src/pages/UploadPage.tsx